<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="conceptForm" class="col-12">
            <!-- Pay Concept Dropdown -->
            <input matInput [formControlName]="'id'" hidden>
            <input matInput [formControlName]="'definitionId'" hidden>
            <div class="row p-0">
                <div class="col-6 input-box">
                    <!-- <i class="material-icons" matTooltip="Zoom in to payroll concept">zoom_in</i> -->
                    <mat-form-field appearance="outline">
                        <mat-label>Pay Concept</mat-label>
                        <mat-select formControlName="payConcept" matTooltip="Type of payroll concept to use" required>
                            <mat-option *ngFor="let concept of concepts" [value]="concept.HR_Concept_ID">
                                {{ concept.Name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="conceptForm.get('payConcept')?.hasError('required')">
                            Pay Concept is required.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Radio Buttons for Computations -->
            <div class="row mt-1">
                <div class="col-6">
                    <mat-checkbox formControlName="computePagIbig"
                        matTooltip="If checked, Pag-ibig will be computed based on this defintion's amount; otherwise, no computation">
                        Compute Pag-IBIG
                    </mat-checkbox>
                </div>

                <div class="col-6">
                    <mat-checkbox formControlName="computePhilhealth"
                        matTooltip="If checked, Philhealth will be computed based on this defintion's amount; otherwise, no computation">
                        Compute PhilHealth
                    </mat-checkbox>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <mat-checkbox formControlName="computeSSS"
                        matTooltip="If checked, SSS will be computed based on this definition's amount; otherwise, no computation.">
                        Compute SSS
                    </mat-checkbox>
                </div>

                <div class="col-6">
                    <mat-checkbox formControlName="computeLate"
                        matTooltip="If checked, late and undertime will be deducted from the fixed salary.">
                        Compute Late/Undertime From Fixed Salary
                    </mat-checkbox>
                </div>
            </div>

            <!-- Dropdowns for Matrix -->
            <div class="row">
                <mat-form-field class="col-6" *ngIf="conceptForm.get('computePagIbig')?.value === true"
                    appearance="outline">
                    <mat-label>Pag-IBIG Matrix</mat-label>
                    <mat-select formControlName="matrixPagIbig"
                        matTooltip="Select the appropriate Pag-IBIG matrix for computation.">
                        <mat-option *ngFor="let mat of matrix" [value]="mat.RAMP_Matrix_ID">
                            {{ mat.Name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="conceptForm.get('matrixPagIbig')?.hasError('required')">
                        Pag-IBIG Matrix is required.
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="col-6" *ngIf="conceptForm.get('computePhilhealth')?.value === true" appearance="outline">
                    <mat-label>PhilHealth Matrix</mat-label>
                    <mat-select formControlName="matrixPhilhealth"
                        matTooltip="Select the appropriate PhilHealth matrix for computation.">
                        <mat-option *ngFor="let mat of matrix" [value]="mat.RAMP_Matrix_ID">
                            {{ mat.Name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="conceptForm.get('matrixPhilhealth')?.hasError('required')">
                        PhilHealth Matrix is required.
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field class="col-6" *ngIf="conceptForm.get('computeSSS')?.value === true" appearance="outline">
                    <mat-label>SSS Matrix</mat-label>
                    <mat-select formControlName="matrixSSS"
                        matTooltip="Select the appropriate SSS matrix for computation.">
                        <mat-option *ngFor="let mat of matrix" [value]="mat.RAMP_Matrix_ID">
                            {{ mat.Name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="conceptForm.get('matrixSSS')?.hasError('required')">
                        SSS Matrix is required.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="btn btn-success yes-button" [disabled]="conceptForm.invalid" (click)="save()"
            *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial>{{data.confirmText}}</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>